import domain from "@/environment";
import axios from "axios";

const state = {
  cee: null,
  cees: [],
  ceeRows: 0,
  ceeLoading: false,
  error: null,
};

const getters = {
  getCEE: (state) => state.cee,
  getAllCEE: (state) => {
    if (!state.cees || !Array.isArray(state.cees)) {
      return [];
    }
    return state.cees.filter(item => item !== null && item !== undefined);
  },
  getTotalRowCEE: (state) => state.ceeRows,
  getCEELoading: (state) => state.ceeLoading,
  getCEEError: (state) => state.error,
};

const mutations = {
  DO_NOTHING() {},
  SET_CEE_LOADING(state, payload) {
    state.ceeLoading = payload || false;
  },
  SET_CEE(state, payload) {
    state.cee = payload ? payload : null;
  },
  SET_CEES(state, payload) {
    if (payload && Array.isArray(payload)) {
      state.cees = payload;
    } else {
      state.cees = [];
    }
  },
  PUSH_CEE(state, payload) {
    state.cees.push(payload);
  },
  UPDATE_CEE(state, payload) {
    for (let index = 0; index < state.cees.length; index++) {
      if (state.cees[index].id === payload.id) {
        state.cees[index] = payload;
        break;
      }
    }
  },
  DELETE_CEE(state, payload) {
    state.cees = state.cees.filter((item) => item.id !== payload.id);
  },
  UPDATE_CEE_ROW(state, payload) {
    state.ceeRows = payload ? payload : 0;
  },
  SET_CEE_ERROR(state, payload) {
    state.error = payload ? payload : null;
  },
};

const actions = {
  async allCEE({ commit }, payload) {
    commit("SET_CEE_LOADING", true);
    const params = {
      page: payload?.page || 1,
      per_page: payload?.per_page || 10,
      search: payload?.search || null,
      start_date: payload?.start_date || null,
      end_date: payload?.end_date || null,
      entreprise: payload?.entreprise ? payload.entreprise.id : null,
      entreprise_id: payload?.entreprise_id || null,
      delegataire_id: payload?.delegataire_id || null,
      client_id: payload?.client_id || null,
      ocrdossier_id: payload?.ocrdossier_id || null,
    };
    try {
      const response = await axios.get(domain + "/cees", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });

      // Extract data from Laravel pagination response
      // Structure: { status, status_code, message, data: { current_page, data: [...], total, ... } }
      let ceeData = [];
      let totalRows = 0;
      
      if (response.data && response.data.data) {
        const paginationData = response.data.data;
        // Check if paginationData.data exists (the actual array of CEEs)
        if (paginationData.data && Array.isArray(paginationData.data)) {
          ceeData = paginationData.data.filter(item => item !== null && item !== undefined);
          totalRows = paginationData.total || 0;
        } else if (Array.isArray(paginationData)) {
          // Fallback: if data is directly an array
          ceeData = paginationData.filter(item => item !== null && item !== undefined);
        }
      }
      
      commit("SET_CEES", ceeData);
      commit("UPDATE_CEE_ROW", totalRows);
      commit("SET_CEE_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_CEE_LOADING", false);
      commit(
        "SET_CEE_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async getOneCEE({ commit }, payload) {
    commit("SET_CEE_LOADING", true);
    try {
      const response = await axios.get(domain + `/cees/` + payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_CEE", response.data.data);
      commit("SET_CEE_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_CEE_LOADING", false);
      commit(
        "SET_CEE_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async storeCEE({ commit }, payload) {
    commit("SET_CEE_LOADING", true);
    try {
      const response = await axios.post(domain + `/cees`, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("PUSH_CEE", response.data.data);
      commit("SET_CEE_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_CEE_LOADING", false);
      commit(
        "SET_CEE_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async updateCEE({ commit }, payload) {
    commit("SET_CEE_LOADING", true);
    try {
      const response = await axios.put(domain + `/cees/` + payload.id, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("UPDATE_CEE", response.data.data);
      commit("SET_CEE_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_CEE_LOADING", false);
      commit(
        "SET_CEE_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async deleteCEE({ commit }, payload) {
    commit("SET_CEE_LOADING", true);
    try {
      await axios.delete(domain + `/cees/` + payload.id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("DELETE_CEE", payload);
      commit("SET_CEE_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_CEE_LOADING", false);
      commit(
        "SET_CEE_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async generatePdfCEE({ commit }, payload) {
    commit("SET_CEE_LOADING", true);
    try {
      const response = await axios.get(domain + `/cees/` + payload + `/generate-pdf`, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_CEE_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_CEE_LOADING", false);
      commit(
        "SET_CEE_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async downloadPdfCEE({ commit }, payload) {
    commit("SET_CEE_LOADING", true);
    try {
      const response = await axios.get(domain + `/cees/` + payload + `/download-pdf`, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_CEE_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_CEE_LOADING", false);
      commit(
        "SET_CEE_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },
};

export default { state, mutations, getters, actions };

